import { useState, useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { getMe } from '@/lib/api';
import { Loader2 } from 'lucide-react';

export function ProtectedRoute({ children, adminOnly = false }) {
  const location = useLocation();
  
  // Check for cached user first
  const getCachedUser = () => {
    const cached = localStorage.getItem('user');
    if (cached) {
      try {
        return JSON.parse(cached);
      } catch (e) {
        return null;
      }
    }
    return null;
  };
  
  const [isAuthenticated, setIsAuthenticated] = useState(
    location.state?.user ? true : (getCachedUser() ? true : null)
  );
  const [user, setUser] = useState(location.state?.user || getCachedUser());

  useEffect(() => {
    // Skip if user data passed from AuthCallback or already have cached user
    if (location.state?.user) return;

    const checkAuth = async () => {
      try {
        const response = await getMe();
        setUser(response.data);
        setIsAuthenticated(true);
        localStorage.setItem('user', JSON.stringify(response.data));
      } catch (error) {
        setIsAuthenticated(false);
        setUser(null);
        localStorage.removeItem('user');
        localStorage.removeItem('session_token');
      }
    };

    checkAuth();
  }, [location.state]);

  // Still checking
  if (isAuthenticated === null) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <Loader2 className="h-12 w-12 animate-spin text-stone-900" />
      </div>
    );
  }

  // Not authenticated - redirect to login with current location
  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Admin check - redirect to admin login if not admin
  if (adminOnly && user?.role !== 'admin') {
    return <Navigate to="/admin/login" replace />;
  }

  return children;
}